module.exports = __webpack_public_path__ + "static/media/alert.49fae68e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/alert.png
// module id = 86
// module chunks = 0